export const ShadowForCurves: React.CSSProperties = {
  boxShadow: "0px 0px 18px 12px rgba(0,0,0,0.45)",
};
